import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FFHBox from './ffhBox';
import FictionBox from './fictionBox';

class FTNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { ffhData, fictionData },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <FFHBox content={ffhData} />
                    <FictionBox content={fictionData} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(FTNews);
